import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	NewAssignment: {
		k: "assignment.new",
		v: "Create New Assignment"
	},
	EditAssignment: {
		k: "assignment.edit",
		v: "Edit"
	},
	FilterAssignment: {
		k: "assignment.filter",
		v: "Filter"
	}
});


// WEBPACK FOOTER //
// ./src/panels/testAssignment/Assignment.labels.ts